import * as React from "react";
import PropTypes from "prop-types";
import Backbone from "backbone";
import SlideToUnlock from "nx-components/SlideToUnlock";
import CommonControlWrapper from "nexia_mobile/components/Controls/wrappers/CommonControlWrapper";

export default class LockAndUnlock extends React.Component {
  static propTypes = {
    model: PropTypes.instanceOf(Backbone.Model).isRequired,
    isDetailed: PropTypes.bool.isRequired,
    showSpinner: PropTypes.func.isRequired, // (?string) => void
    hideSpinner: PropTypes.func.isRequired, // () => void
  };

  state = {
    pendingLockedValue: null,
  };

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  _setPendingLockedValue(pendingLockedValue) {
    if (!this._isMounted) {
      return;
    }
    this.setState({ pendingLockedValue });
  }

  render() {
    const { model, isDetailed, showSpinner, hideSpinner } = this.props;
    const { pendingLockedValue } = this.state;

    const isLocked = model.get("isLocked");
    const isUnlocked = model.get("isUnlocked");

    let action;
    let message;
    if (!isLocked) {
      action = () => {
        this._setPendingLockedValue(true);
        const resetPending = () => {
          this._setPendingLockedValue(null);
        };
        return model.lock().then(resetPending, resetPending);
      };
      message = `Locking '${model.get("name")}'`;
    } else {
      action = () => {
        this._setPendingLockedValue(false);
        const resetPending = () => {
          this._setPendingLockedValue(null);
        };
        return model.unlock().then(resetPending, resetPending);
      };
      message = `Unlocking '${model.get("name")}'`;
    }

    const locked = pendingLockedValue == null ? isLocked : pendingLockedValue;

    return (
      <CommonControlWrapper isDetailed={isDetailed}>
        <SlideToUnlock
          disabled={!isLocked && !isUnlocked}
          locked={locked}
          onChange={() => {
            showSpinner(message);
            action().then(hideSpinner, hideSpinner);
          }}
        />
      </CommonControlWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Controls/LockAndUnlock.jsx